const actionTypes = {
    GET_CALCULATION_FIELD_SUCCESS: 'GET_CALCULATION_FIELD_SUCCESS',
    GET_CALCULATION_FILTER_SUCCESS: 'GET_CALCULATION_FILTER_SUCCESS',
};

export default actionTypes;
